import dayjs from "dayjs";
import { z } from "@/helpers/forms/zod";

import { tolgee } from "@/providers/TranslationProvider";

export const retroplanningFormPageSchema = z
  .object({
    createdAt: z.date(),
    QUOTE_TO_VALIDATE: z.date().optional().nullable(),
    HD_FILE_MISSING: z.date().optional().nullable(),
    PROOF_TO_VALIDATE: z.date().optional().nullable(),
    PURCHASE_ORDER_MISSING: z.date().optional().nullable(),
    deliveryDate: z.date(),
  })
  .superRefine((retroplanning, ctx) => {
    // Check if the QUOTE_TO_VALIDATE date is between the createdAt and the deliveryDate
    if (
      retroplanning.QUOTE_TO_VALIDATE &&
      !dayjs(retroplanning.QUOTE_TO_VALIDATE).isBetween(
        dayjs(retroplanning.createdAt),
        dayjs(retroplanning.deliveryDate),
        "day",
        "()"
      )
    ) {
      ctx.addIssue({
        code: "custom",
        path: ["QUOTE_TO_VALIDATE"],
        message: tolgee.t("oms.addRetroplanning.errorDateRange", {
          firstDate: dayjs(retroplanning.createdAt).add(1, "day").format("L"),
          lastDate: dayjs(retroplanning.deliveryDate)
            .subtract(1, "day")
            .format("L"),
        }),
      });
    }

    // Check if the HD_FILE_MISSING date is between the createdAt and the deliveryDate
    if (
      retroplanning.HD_FILE_MISSING &&
      !dayjs(retroplanning.HD_FILE_MISSING).isBetween(
        dayjs(retroplanning.createdAt),
        dayjs(retroplanning.deliveryDate),
        "day",
        "()"
      )
    ) {
      ctx.addIssue({
        code: "custom",
        path: ["HD_FILE_MISSING"],
        message: tolgee.t("oms.addRetroplanning.errorDateRange", {
          firstDate: dayjs(retroplanning.createdAt).add(1, "day").format("L"),
          lastDate: dayjs(retroplanning.deliveryDate)
            .subtract(1, "day")
            .format("L"),
        }),
      });
    }

    // Check if the PROOF_TO_VALIDATE date is between the createdAt and the deliveryDate
    if (
      retroplanning.PROOF_TO_VALIDATE &&
      !dayjs(retroplanning.PROOF_TO_VALIDATE).isBetween(
        dayjs(retroplanning.createdAt),
        dayjs(retroplanning.deliveryDate),
        "day",
        "()"
      )
    ) {
      ctx.addIssue({
        code: "custom",
        path: ["PROOF_TO_VALIDATE"],
        message: tolgee.t("oms.addRetroplanning.errorDateRange", {
          firstDate: dayjs(retroplanning.createdAt).add(1, "day").format("L"),
          lastDate: dayjs(retroplanning.deliveryDate)
            .subtract(1, "day")
            .format("L"),
        }),
      });
    }

    // Check if the QUOTE_TO_VALIDATE date is between the createdAt and the deliveryDate
    if (
      retroplanning.PURCHASE_ORDER_MISSING &&
      !dayjs(retroplanning.PURCHASE_ORDER_MISSING).isBetween(
        dayjs(retroplanning.createdAt),
        dayjs(retroplanning.deliveryDate),
        "day",
        "()"
      )
    ) {
      ctx.addIssue({
        code: "custom",
        path: ["PURCHASE_ORDER_MISSING"],
        message: tolgee.t("oms.addRetroplanning.errorDateRange", {
          firstDate: dayjs(retroplanning.createdAt).add(1, "day").format("L"),
          lastDate: dayjs(retroplanning.deliveryDate)
            .subtract(1, "day")
            .format("L"),
        }),
      });
    }
  });

export type InferredRetroplanningFormPageSchema = z.infer<
  typeof retroplanningFormPageSchema
>;
